import { ArrayDataSource, SelectionModel } from '@angular/cdk/collections';
import { NestedTreeControl } from '@angular/cdk/tree';
import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';


import { Lookup } from 'src/app//shared/models/lookups/Lookup';

@Component({
  selector: 'app-tree-selection',
  templateUrl: './tree-selection.component.html'
})
export class TreeSelectionComponent implements OnInit {

  selectedItems: any = [];

  @Input() isView = false;
  @Input() formField = false;
  @Input() classificationCode: any;
  @Output() SelectedItems = new EventEmitter<any>();
  @Input() selectedInput: any;


  /** The selection for checklist */
  @Input() TREE_DATA: Lookup[] = [];
  treeSelection = new SelectionModel<Lookup>(true /* multiple */);
  treeControl = new NestedTreeControl<Lookup>((node: any) => node.childs);
  treeDataSource = new ArrayDataSource(this.TREE_DATA);
  hasChild = (_: number, node: Lookup) => !!node.childs && node.childs.length > 0;

  constructor() {
  }

  ngOnInit(): void {
    this.treeDataSource = new ArrayDataSource(this.TREE_DATA);
    if (this.selectedInput) {
      this.updateTree();
    }
  }
  // [compareWith]="schemaCompare"
  // schemaCompare(o1, o2): boolean {
  //   return o1 && o2 ? o1 === o2.schema_token : o2.schema_token === o2.schema_token;
  // }

  updateTree() {
    this.treeDataSource['_data'].forEach((parent: any) => {
      if (this.selectedInput === 'all') {
        this.treeSelection.toggle(parent);
        if (parent.childs && parent.childs.length) {
          parent.childs.forEach((element: any) => {
            this.treeSelection.toggle(element);
          });
        }
      } else {
        if (parent.childs && parent.childs.length) {
          let childsCount = 0;
          this.selectedInput.forEach((relatedParent: any) => {
            if (typeof relatedParent === 'object' && relatedParent !== null) {
              if (relatedParent.id === parent.id) {
                if (parent.childs.length === relatedParent.childs.length) {
                  this.treeSelection.toggle(parent);
                }
                relatedParent.childs.forEach((child: any) => {
                  const itemFound = parent.childs.find((item: any) => child.id === item.id);
                  if (itemFound) {
                    this.treeSelection.toggle(itemFound);
                  }
                });
              }
            } else {
              const itemFound = parent.childs.find((item: any) => relatedParent === item.id);
              if (itemFound) {
                this.treeSelection.toggle(itemFound);
                childsCount = childsCount + 1;
              }
              if (childsCount === parent.childs.length) {
                this.treeSelection.select(parent);
              }
            }
          });
        }
      }
    });
    if (this.formField) {
      setTimeout(() => {
        this.SelectedItems.emit(this.treeSelection.selected);
      }, 10);
    }
  }

  // TREE   configrations //////////////////////////////////////////
  /** Whether all the descendants of the node are selected */
  descendantsAllSelected(node: Lookup): boolean {
    const descendants = this.treeControl.getDescendants(node);
    return descendants.every((child: any) => this.treeSelection.isSelected(child));
  }

  /** Whether part of the descendants are selected */
  descendantsPartiallySelected(node: Lookup): boolean {
    const descendants = this.treeControl.getDescendants(node);
    const result = descendants.some((child: any) => this.treeSelection.isSelected(child));
    return result && !this.descendantsAllSelected(node);
  }

  /** Toggle the to-do item selection. Select/deselect all the descendants node */
  todoItemSelectionToggle(node: Lookup): void {
    this.treeSelection.toggle(node);
    const descendants = this.treeControl.getDescendants(node);
    this.treeSelection.isSelected(node)
      ? this.treeSelection.select(...descendants)
      : this.treeSelection.deselect(...descendants);
  }
  // END TREE   configrations //////////////////////////////////////////

  isInArray(parentObj: any, item: any) {
    return parentObj.some((obj: any) => obj.id === item.id);
  }

  selected(node: any) {
    this.SelectedItems.emit(this.treeSelection.selected);
  }
}
